"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotomeasureCollectionList = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var mithril_component_1 = require("../../components/mithril.component");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var page_1 = require("../../page/page");
var page_state_1 = require("../../state/page.state");
var tag_sort_state_1 = require("../../state/tag.sort.state");
var store_1 = require("../../store");
var capture_bar_1 = require("../capture.bar/capture.bar");
var collection_list_1 = require("../collection.list/collection.list");
var collection_toolbar_1 = require("../collection.toolbar/collection.toolbar");
var tag_map_1 = require("../tag.map/tag.map");
var photomeasure_collection_list_style_1 = require("./photomeasure.collection.list.style");
var photomeasure_map_overlay_1 = require("./photomeasure.map.overlay");
(0, theme_1.addStyles)(photomeasure_collection_list_style_1.Style);
var PhotomeasureCollectionList = /** @class */ (function (_super) {
    tslib_1.__extends(PhotomeasureCollectionList, _super);
    function PhotomeasureCollectionList(state) {
        var _this = _super.call(this) || this;
        _this.state = state;
        _this.toolbar = new collection_toolbar_1.CollectionToolbar(_this.state, {
            mapZoomOut: false,
            title: i18n_1.T.COLLECTION_TITLE
        });
        _this.map = new tag_map_1.TagMap(_this.state);
        _this.overlay = new photomeasure_map_overlay_1.PhotomeasureMapOverlay({
            capture: _this.inspectedCapture
        });
        _this.reaction(function () { return _this.collection; }, _this.ensureCollectionSelected);
        _this.reaction(function () { return _this.inspectedCapture; }, function () {
            var current = (0, lodash_1.get)(_this.overlay, ['capture', 'objectId'], null);
            var next = (0, lodash_1.get)(_this, ['inspectedCapture', 'objectId'], null);
            if (next !== current) {
                _this.overlay.setCapture(_this.inspectedCapture);
            }
        });
        return _this;
    }
    Object.defineProperty(PhotomeasureCollectionList.prototype, "inspectedCapture", {
        get: function () {
            var _a;
            var inspectedCaptureId = page_state_1.CurrentState.inspectedCaptureId, inspectedCollectionRevision = page_state_1.CurrentState.inspectedCollectionRevision;
            if (inspectedCaptureId && inspectedCollectionRevision) {
                return (_a = store_1.AppStore.Collection.get(inspectedCollectionRevision)) === null || _a === void 0 ? void 0 : _a.state.getCapture(inspectedCaptureId);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhotomeasureCollectionList.prototype, "nodes", {
        get: function () {
            var collectionSummaries = this.visibleCollections;
            if (collectionSummaries == null) {
                return (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.container }, [
                    (0, mithril_1.m)('div', { className: "".concat(photomeasure_collection_list_style_1.CSS.collections.content, " ").concat(photomeasure_collection_list_style_1.CSS.collections.isEmpty) }, collection_list_1.CollectionList.viewLoading(page_state_1.CurrentState.inspectedTagId)),
                    capture_bar_1.CaptureBar.view()
                ]);
            }
            var tag = store_1.AppStore.Tag.get(page_state_1.CurrentState.inspectedTagId);
            var inspectedCollection = this.collection;
            return (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.collections.container }, [
                    (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.toolbar.container }, this.toolbar.view()),
                    (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.collections.content }, [
                        collection_list_1.CollectionList.view(this.state, tag, collectionSummaries),
                        capture_bar_1.CaptureBar.view(inspectedCollection)
                    ])
                ]),
                (0, mithril_1.m)('div', { className: photomeasure_collection_list_style_1.CSS.map.container }, this.map.view()),
                this.viewMapButton(inspectedCollection)
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhotomeasureCollectionList.prototype, "visibleCollections", {
        get: function () {
            if (page_state_1.CurrentState.inspectedTagId == null || store_1.AppStore.Tag.get(page_state_1.CurrentState.inspectedTagId) == null) {
                return null;
            }
            var tagSummary = store_1.AppStore.TagSummary.get(page_state_1.CurrentState.inspectedTagId);
            var revisions = tagSummary != null ? tagSummary.revisions : [];
            var collectionSummaries = [];
            for (var _i = 0, revisions_1 = revisions; _i < revisions_1.length; _i++) {
                var revision = revisions_1[_i];
                var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                if (collectionSummary != null) {
                    collectionSummaries.push(collectionSummary);
                }
            }
            tag_sort_state_1.TagSortState.sortSummaries(collectionSummaries);
            page_state_1.CurrentState.Tag.resetLastSelectedCollectionIndex();
            page_state_1.CurrentState.Tag.setExpandedCollectionsUUIDs(collectionSummaries.map(function (_) { return _.uuid; }));
            return collectionSummaries;
        },
        enumerable: false,
        configurable: true
    });
    PhotomeasureCollectionList.prototype.ensureCollectionSelected = function () {
        var tagId = page_state_1.CurrentState.inspectedTagId;
        var tagSummary = store_1.AppStore.TagSummary.get(tagId);
        page_state_1.CurrentState.setInspectedTagId(tagId);
        if (tagSummary != null && tagSummary.revisions.indexOf(page_state_1.CurrentState.inspectedCollectionRevision) === -1) {
            page_state_1.CurrentState.setInspectedCollection(tagSummary.revisions[0]);
        }
    };
    PhotomeasureCollectionList.prototype.viewMapButton = function (collection) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.MAP, {
            className: photomeasure_collection_list_style_1.CSS.map.button,
            title: i18n_1.T.NAVIGATE_MAP,
            type: 'a',
            href: page_1.IkePageName.map,
            hrefParams: collection != null ? { t: collection.jobId, collection: collection.uuid } : null
        });
    };
    Object.defineProperty(PhotomeasureCollectionList.prototype, "collection", {
        get: function () {
            if (page_state_1.CurrentState.CollectionEdit.isEditing) {
                return page_state_1.CurrentState.CollectionEdit.collection;
            }
            return store_1.AppStore.Collection.get(page_state_1.CurrentState.inspectedCollectionRevision);
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], PhotomeasureCollectionList.prototype, "inspectedCapture", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PhotomeasureCollectionList.prototype, "visibleCollections", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], PhotomeasureCollectionList.prototype, "ensureCollectionSelected", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PhotomeasureCollectionList.prototype, "collection", null);
    return PhotomeasureCollectionList;
}(mithril_component_1.IMithrilStateComponent));
exports.PhotomeasureCollectionList = PhotomeasureCollectionList;
//# sourceMappingURL=photomeasure.collection.list.js.map